ClientVersion = require './client-version'
{ locales } = require 'db/locale-information'

locale = locales[0]

module.exports = -> [
  schema: 'iglu:com.trello/web-context/jsonschema/1-0-4',
  data:
    'client_version': ClientVersion.version.toString()
    'client_locale': locale
]



// WEBPACK FOOTER //
// ./app/scripts/debug/get-web-context.coffee